import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  mainContainer: {
    background: `${theme?.palette?.primaryBG?.[700]} !important`,
    display: "flex",
    flexDirection: "column",
    // height: "100%",
    minHeight: "100vh",
    "& .mainContainer": {
      height: "100%",
      margin: "0 12%",
      minHeight: "100%",

      [theme.breakpoints.between(1180, 1440)]: {
        marginLeft: "12%",
        marginRight: "0px"
      },
      [theme.breakpoints.down(1180)]: {
        marginLeft: "13%",
        marginRight: "0px"
      },
      [theme.breakpoints.down(1025)]: {
        margin: "10px",
        padding: "10px"
      },
      [theme.breakpoints.down("md")]: {
        margin: "0px 0px"
      },
      [theme.breakpoints.down("sm")]: {
        marginTop: "0px",
      },
      "& .MuiCalendarOrClockPicker-root": {
        background: theme?.palette?.primaryBG?.[380]
      },
      "& input:-webkit-autofill": {
        boxShadow: `0 0 0 2rem ${theme?.palette?.primaryBG?.[400]} inset !important`,
        "-webkit-text-fill-color": theme?.palette?.primaryText?.[100],
        borderColor: theme?.palette?.primaryBG?.[400],
        caretColor: theme?.palette?.primaryText?.[100],
        borderRadius: "10px !important"
      },
      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
      {
        "-webkit-appearance": "none",
        margin: 0
      },
      "& input[type=number]": {
        "-moz-appearance": "textfield"
      }
    },
    [theme.breakpoints.down(1100)]: {
      minHeight: "calc(100vh - 350px)"
    },
    [theme.breakpoints.down(900)]: {
      minHeight: "calc(100vh - 100px)"
    }
  },
   sportsContainer: {
    "& .mainContainer": {
      margin: "0px",
    },
    "& .sports-container.sidebar-expanded": {
      marginLeft: "161px",
      [theme.breakpoints.down(1024)]: {
        marginLeft: "0px",
      },
    },
    "& .sports-container.sidebar-collapsed": {
      marginLeft: "0px",
    },
  },
}));
